<template>
  <div>
    <div class="title">院校特色</div>
    <div class="nav" v-for="(item, i) in list" :key="i">
      <div class="specialty_name">{{ item.specialty_name }}</div>
      <div class="level">{{ item.level }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      list: [],
    };
  },
  computed: {
  },
  created() {
    this.getShuang()
  },
  methods: {
    getShuang() {
      this.$fecth
        .get("school/getZhuan", { params: { school_id: this.$route.query.cid } })
        .then((res) => {
          res = res.data
          if (res.length > 0) {
            this.list = res
          } else {
            this.$emit('getZhuanState', false)
          }
        });
    },
  },
};
</script>

<style scoped lang='less'>
.title {
  font-size: 22px;
  margin-bottom: 15px;

  .name {
    margin-right: 70px;
  }

  .title-t {
    border: 1px solid #4591F6;
    color: #4591F6;
    margin-right: 20px;
    padding: 2px 10px;
    border-radius: 5px;
    font-size: 18px;
  }
}

.nav {

  display: inline-block;
  margin-top: 20px;
  margin-right: 20px;

  border-radius: 3px;
}

.specialty_name {
  background: #F5F5F5;
  padding: 15px 15px;
}

.level {
  text-align: center;
  background: #4591F6;
  color: white;
  padding: 5px 15px;
}
</style>
